import React, { useContext, useReducer } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Layout } from 'antd';
import Router from '@/router';
import styles from './index.module.scss';
import GlobalState from '@/global';
import Header from '@component/header';
import Footer from '@component/footer';
import elL1Img from '@/imagesNew/el-l1.png'
import elL2Img from '@/imagesNew/el-l2.png'
import elR1Img from '@/imagesNew/el-r1.png'

export default function PageLayout() {




  const { dispatch } = GlobalState.useContainer();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  return (
    <Layout>
      {/* <img className={`${styles.el} ${styles.l1}`} src={elL1Img} alt="" />
      <img className={`${styles.el} ${styles.l2}`} src={elL2Img} alt="" />
      <img className={`${styles.el} ${styles.r1}`} src={elR1Img} alt="" /> */}
      <Header />
      <Layout className={styles.main}>
        <img className={`${styles.el} ${styles.l1}`} src={elL1Img} alt="" />
        <img className={`${styles.el} ${styles.l2}`} src={elL2Img} alt="" />
        <img className={`${styles.el} ${styles.r1}`} src={elR1Img} alt="" />
        <Router />
      </Layout>
      <Footer />
    </Layout>
  );
}
